// One primary audio at a time. Players claim focus when they start; every
// other subscriber pauses itself in response, and the ambience bed ducks
// under whichever player holds focus. Module-level bus so players that live
// in different subtrees (brief card, reset modal) need no prop-drilling.
type Listener = (owner: string) => void;

const listeners = new Set<Listener>();

export function onAudioFocusClaimed(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function claimAudioFocus(owner: string): void {
  for (const listener of listeners) listener(owner);
}
